import { createColumn, defaultColumns, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Company',
    field: 'companyId',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'companyId',
      fk: 'companyId',
      namespace: 'company',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'Primary Group',
    field: 'primaryGroupId',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'primaryGroupId',
      fk: 'primaryGroupId',
      namespace: 'primaryGroup',
      filterIs: 'text-filter'
    })
  })
].concat(defaultColumns)
